export default __webpack_public_path__ + "static/social-iceland-4afbbd0b3d269e61fd98d5ff7b6fc30b.jpg";